import { useEffect } from "react";
import { CheckCircle, X } from "lucide-react";

function FeatureModal({ data, onClose }) {

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = "auto"; };
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6 sm:py-10"
      style={{ backdropFilter: "blur(6px)", backgroundColor: "rgba(0,0,0,0.45)" }}
      onClick={onClose}
    >
      <div
        className="relative bg-white w-full max-w-2xl rounded-2xl shadow-2xl flex flex-col"
        style={{ animation: "modalIn 0.25s ease-out both", maxHeight: "90vh" }}
        onClick={(e) => e.stopPropagation()}
      >

        {/* ── HEADER ─────────────────────────────────── */}
        <div className="flex-shrink-0 bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-6 sm:px-8 py-6 rounded-t-2xl relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors duration-200"
          >
            <X size={16} />
          </button>

          <div className="flex items-start gap-4 pr-8">
            <div className="flex-shrink-0 w-11 h-11 bg-white/20 rounded-xl flex items-center justify-center text-white">
              {data.icon}
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl font-bold leading-snug">{data.title}</h2>
              <p className="text-blue-100 mt-1.5 text-sm sm:text-base leading-relaxed">{data.subtitle}</p>
            </div>
          </div>
        </div>

        {/* ── BODY ───────────────────────────────────── */}
        <div className="overflow-y-auto px-6 sm:px-8 py-6 space-y-6">

          {/* Overview — no heading, matches screenshot */}
          <p className="text-gray-600 text-sm sm:text-base leading-relaxed">{data.overview}</p>

          {/* Key Features */}
          <div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-3">Key Features</h3>
            <ul className="space-y-1">
              {data.features.map((item, i) => (
                <li
                  key={i}
                  className="
                    flex items-center gap-3
                    px-4 py-3 rounded-xl
                    text-gray-700 text-sm sm:text-base
                    transition-colors duration-200 cursor-default
                    hover:bg-blue-50
                  "
                >
                  <CheckCircle size={20} className="text-blue-600 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Benefits */}
          {/* <div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900">Benefits</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
              {data.benefits.map((b, i) => (
                <div key={i} className="border border-blue-200 rounded-xl px-4 py-3 bg-blue-50 text-gray-800 text-sm sm:text-base">
                  {b}
                </div>
              ))}
            </div>
          </div> */}

          {/* Use Case */}
          {/* <div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900">Use Case Example</h3>
            <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mt-3 text-gray-700 text-sm sm:text-base leading-relaxed">
              {data.useCase}
            </div>
          </div> */}

          {/* CTA */}
          <div className="border-t border-gray-100 pt-4">
            <button
              onClick={onClose}
              className="w-full bg-blue-600 hover:bg-blue-700 active:scale-[0.98] text-white py-3.5 rounded-xl font-semibold transition-all duration-200 text-sm sm:text-base"
            >
              Got it, thanks!
            </button>
          </div>

        </div>
      </div>

      <style>{`
        @keyframes modalIn {
          from { opacity: 0; transform: translateY(16px) scale(0.98); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
}

export default FeatureModal;